import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white" data-id="element-174">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#2D3748] mb-6" data-id="element-177">
            Esto no es otra dieta para sufrir
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed" data-id="element-178">
            Si eres una mujer de 65+ y vives en USA, probablemente ya pasaste
            por esto: te prometiste "comer mejor" pero todo es complicado, o te
            dijeron "haz ejercicio" pero tu cuerpo no está para rutinas
            agresivas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16" data-id="element-179">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#FAF7F2] p-8 rounded-2xl border border-[#E07856]/20" data-id="element-180">
            <h3 className="text-2xl font-bold text-[#E07856] mb-4 flex items-center" data-id="element-181">
              <XCircle className="w-8 h-8 mr-3" data-id="element-182" />
              El problema real
            </h3>
            <ul className="space-y-4 text-lg text-gray-700" data-id="element-183">
              <li className="flex items-start" data-id="element-184">
                <span className="mr-2" data-id="element-185">•</span>
                Te despiertas sintiéndote pesada
              </li>
              <li className="flex items-start" data-id="element-186">
                <span className="mr-2" data-id="element-187">•</span>A media tarde la barriga se
                endurece
              </li>
              <li className="flex items-start" data-id="element-188">
                <span className="mr-2" data-id="element-189">•</span>
                La ropa aprieta y molesta
              </li>
              <li className="flex items-start" data-id="element-190">
                <span className="mr-2" data-id="element-191">•</span>
                Sientes que es "tu edad" y no hay solución
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-192">
            <h3 className="text-2xl font-bold text-[#2D3748] mb-6" data-id="element-193">
              Por qué lo que probaste falla
            </h3>
            <div className="space-y-6" data-id="element-194">
              <div className="flex items-start" data-id="element-195">
                <div className="flex-shrink-0" data-id="element-196">
                  <AlertCircle className="h-8 w-8 text-[#E07856]" data-id="element-197" />
                </div>
                <div className="ml-4" data-id="element-198">
                  <h4 className="text-xl font-bold text-gray-900" data-id="element-199">
                    Dietas estrictas
                  </h4>
                  <p className="mt-1 text-lg text-gray-600" data-id="element-200">
                    Te dejan con hambre, ansiedad y causan efecto rebote.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-201">
                <div className="flex-shrink-0" data-id="element-202">
                  <AlertCircle className="h-8 w-8 text-[#E07856]" data-id="element-203" />
                </div>
                <div className="ml-4" data-id="element-204">
                  <h4 className="text-xl font-bold text-gray-900" data-id="element-205">
                    Recetas "Fit" complicadas
                  </h4>
                  <p className="mt-1 text-lg text-gray-600" data-id="element-206">
                    Ingredientes raros, mucho tiempo en la cocina y muy caras.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-207">
                <div className="flex-shrink-0" data-id="element-208">
                  <AlertCircle className="h-8 w-8 text-[#E07856]" data-id="element-209" />
                </div>
                <div className="ml-4" data-id="element-210">
                  <h4 className="text-xl font-bold text-gray-900" data-id="element-211">
                    Ejercicio intenso
                  </h4>
                  <p className="mt-1 text-lg text-gray-600" data-id="element-212">
                    Duele, asusta y se termina abandonando a los pocos días.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center bg-[#5B9BD5]/10 p-8 rounded-xl" data-id="element-213">
          <p className="text-2xl font-medium text-[#2D3748]" data-id="element-214">
            No fallaste tú. Falló el enfoque.
            <br data-id="element-215" />
            <span className="text-[#5B9BD5] font-bold" data-id="element-216">
              Necesitas algo diseñado para tu etapa de vida.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}